import { render, staticRenderFns } from "./platform_other_account_list.vue?vue&type=template&id=cd8a9218&scoped=true"
import script from "./platform_other_account_list.vue?vue&type=script&lang=js"
export * from "./platform_other_account_list.vue?vue&type=script&lang=js"
import style0 from "./platform_other_account_list.vue?vue&type=style&index=0&id=cd8a9218&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8a9218",
  null
  
)

export default component.exports